/*
 * This module manages the floating feedback link.
 */
define('feedback-link',['loader', 'jquery', 'angular', 'angular-ui-bootstrap', 'localize', 'vspot', 'vspot-services'], function(loader, $, ng) {
    'use strict';

    var feedback = ng.module('feedback', ['ui.bootstrap', 'localization', 'vspot', 'vspot.services']);

    feedback.controller('MainCtrl', ['$scope', '$uibModal', '$http', 'services.User', '$timeout', function($scope, $uibModal, $http, User, $timeout) {
        $scope.show = true;
        $scope.opaque = false;

        $scope.checkWidth = function() {
            if ($(window).width() < 1040) {
                $scope.opaque = true;
            } else {
                $scope.opaque = false;
            }
        };

        $scope.openFeedbackModal = function() {
            var modalInstance = $uibModal.open({
                templateUrl: '/script/vspot-angular/templates/feedback-modal.html',
                controller: 'ModalCtrl',
                windowClass: 'feedback-modal',
                resolve: {
                    browserInfo: function() {
                        return $http({ method: 'GET', url: '/api/browser_infos' });
                    },
                    user: function() {
                        return User.get();
                    }
                }
            });
        };

        $(window).resize(function() {

            $timeout(function() {
                //do something to update current scope based on the new innerWidth and let angular update the view.
                $scope.checkWidth();
            });
        });

        // Run it the first time
        $scope.checkWidth();

    }]);

    feedback.controller('ModalCtrl', ['$scope', '$uibModalInstance', '$http', 'browserInfo', 'user', function($scope, $uibModalInstance, $http, browserInfo, user) {
        $scope.submitting       = false;
        $scope.form             = {
            em_addr:    user.email,
            name:       $.trim(user.firstName + ' ' + user.lastName)
        };

        ng.forEach(browserInfo.data, function(value, key) {
            $scope.form['browser_' + key] = value;
        });

        $scope.showSuccess      = false;
        $scope.errorMessage     = false;

        $scope.sendFeedback = function() {
            $scope.submitting = true;
            $http.post('/login/email_general_feedback', $scope.form)
                .success(function(data, status, headers, config) {
                    $scope.submitting = false;
                    if(data.valid) {
                        $scope.showSuccess = true;
                    } else {
                        $scope.errorMessage = data.message;
                    }
                });
        };

        $scope.dismiss = function() {
            $uibModalInstance.close();
        };
    }]);
});
